<template>
  <div class="activity-submission-learner-page">
    <div class="activity-submission-content">
      <activity-submission-element
       :key="item.uuid"
        v-for="item in submission"
        :elementData="item"
      ></activity-submission-element>
      <div class="rubrics">
        <coach-rubrics
          ref="coachRubrics"
          :feedbackUuid="feedbackUuid"
          :feedback="feedback"
          :element_uuid="submissionUuid"
          :form="formType"
          mode="learner"
          submission-view-mode="true"
        />
      </div>
    </div>
    <div class="btn-bottom">
      <md-button :href="user_info.activityUrl" class="md-raised md-primary fb-next">Review Activity</md-button>
    </div>
  </div>
</template>
<script>
import CoachRubrics from "./components/CoachRubrics";

export default {
  name: "ActivitySubmission",
  components: {
    CoachRubrics,
  },
  mounted() {
    this.getFeedback().then((data) => {
      if (data && data.length) {
        this.feedback = data[0].attributes.comment && data[0].attributes.comment.value
          ? data[0].attributes.comment.value
          : "";
        this.feedbackUuid = data[0].id;
      }
      else {
        this.feedback = "";
      }
    });

    if (window.drupalSettings.controller) {
      this.user_info = window.drupalSettings.controller.user_info
        ? window.drupalSettings.controller.user_info
        : [];
    }
  },
  data() {
    return {
      submission: window.drupalSettings.activitySubmission,
      submissionUuid: window.drupalSettings.activitySubmissionUuid,
      formType: window.drupalSettings.activitySubmissionFormType,
      feedback: null,
      feedbackUuid: null,
      user_info: [],
    };
  },
  methods: {
    log(msg) {
      console.log(msg);
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          return text;
        });
    },
    getFeedback() {
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch(
          "/jsonapi/catch_comment/catch_comment?include=user,attached_file" +
            "&filter[element_uuid][condition][path]=element_uuid" +
            "&filter[element_uuid][condition][operator]=IS NULL" +
            "&filter[user.id][value]=" +
            window.drupalSettings.user.uuid +
            "&filter[submission_uuid]=" +
            this.submissionUuid,
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            let included = {};
            if (json.included) {
              json.included.forEach((data) => {
                included[data.id] = data;
              });
            }
            let comments = json.data.map((comment) => {
              let userUuid = comment.relationships.user.data.id;
              let files =
                comment.relationships.attached_file &&
                comment.relationships.attached_file.data
                  ? comment.relationships.attached_file.data
                  : null;
              let user = included[userUuid];

              comment.files = [];
              if (files) {
                files.map((file) => {
                  comment.files.push(included[file.id]);
                });
              }
              comment.user = user;

              comment.canDelete =
                window.drupalSettings.user.uid ==
                  user.attributes.drupal_internal__uid ||
                window.drupalSettings.user.uid == 1;

              return comment;
            });
            return comments;
          });
      });
    },
  },
};
</script>
<style lang="scss">
.activity-submission-learner-page {
  .activity-submission-content {
    margin-top: 25px;
  }

  .rubrics-content > ul li.rubrics-content-expand {
    margin: 0 -25px 35px -25px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .btn-bottom {
    margin-top: 10px;
    text-align: center;

    .md-primary {
      background-color: $blue-dark!important;
    }
  }
}
</style>

